import { storage } from '../js/Storage.js'

const data = {
  context: null,
  sharerName: null,
  metadata: null,
  shareToken: null
}

const mutations = {
  setMetadata (state, metadata) {
    const { shareType, sharerName, sharerMsg, progId } = metadata
    state.progId = progId
    state.context = shareType
    state.sharerName = sharerName
    state.sharerMsg = sharerMsg
  },

  setShareToken (state, token) {
    state.shareToken = token
  }
}
const actions = {
  getShareToken ({ commit, state }, queryToken) {
    if (!state.shareToken) {
      let shareTokenFromQuery = queryToken
      if (!shareTokenFromQuery) {
        const token = storage.getShareToken()
        if (token) {
          try {
            shareTokenFromQuery = JSON.parse(token)
          } catch (e) {
            console.info('error: ' + e.message)
          }
        }
      }
      if (shareTokenFromQuery) {
        storage.saveShareToken(JSON.stringify(shareTokenFromQuery))
      }
      commit('setShareToken', shareTokenFromQuery)
    }
  },
  getMetadata ({ state }) {
    return state.metadata
  }
}

export default {
  namespaced: true,
  state: data,
  mutations: mutations,
  actions: actions
}
